import { useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import Session from '../shared/Session';


export default function Chat() {
    const [messages, setMessages]: [any, any] = useState([]);
    
    Session.wsSubscriptions.push("chat");
    Session.wsHook["chat"] = (data: any) => {
        const newMessages = messages.concat(<p>{data.message}</p>);
        setMessages(newMessages);
    }

    return <>
        <Typography variant="h4" align="left" gutterBottom component="h4">
            Chat
        </Typography>
        {messages}
        <FormControl style={{ bottom: "1.5em", position: "absolute" }}>
            <TextField
                id="newMessageField"
                placeholder="Your Message"
                type="text"
                required={false}
                variant="standard"
                size="medium"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        let messageField = document.getElementById("newMessageField") as HTMLInputElement;
                        let message = messageField.value;
                        messageField.value = "";
                        Session.ws.send(JSON.stringify({ type: "chat", message: message }));
                    }
                }}
            />
        </FormControl>

    </>
}
